import React from 'react';
import * as actions from '../Actions';
import SliderMagazines from '../swiper/sliderMagazine'
export default function ({ highlightsfeed, eleRef }) {

    return (
                         <section className="main_container_block_feeds">
                            <div className="block_magazine_articles_view main_block_container_feed top_categories_2">
                               <div className="magazine_articles_header_title R15_61">
                                   {highlightsfeed.title}
                                </div>
                                <div className="block_magazine_main-view-baby-week feed_desktop_border21">
                                    <div className="content-div_view_artical">
                                        <div className="content-div_view_artical box-circle-artical">
                                          <SliderMagazines page={"dr-carousel-unit"} data={highlightsfeed.data} />
                                       </div>
                                    </div>
                                    <div className="magazine_content_discription"> 
                                        <div className="fabulous_text M16_21"> 
                                          {highlightsfeed.data[0].magazineTitle?highlightsfeed.data[0].magazineTitle:''} 
                                        </div>
                                        <div className="magazine_view_social">
                                           <div className="magazine_social_name R15_75"> {highlightsfeed.data[0].magazineWriter?highlightsfeed.data[0].magazineWriter:''} </div>
                                           <div className="magazine_social_name R15_bd"> {highlightsfeed.data[0].createdDate? actions.time_ago(highlightsfeed.data[0].createdDate):''} </div>
                                           <div className="magazine_social_name font-sizeview" data-icon-font="$"> <span className="icons-text R1_61"> {highlightsfeed.data[0].viewsCount}</span> </div>
                                        </div>
                                        <a href='https://parenting.firstcry.com/articles/category/magazine/'>
                                        <div className="magazine_view_more M15_21"> View More </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                              )
}
